import $ from "jquery";
import Cookies from 'js-cookie';



class Cookiebar {

    constructor() {
        if (Cookies.get('cookieconsent')) {
            // Consent already given
            this.applySettings();
        } else {
            // New user
            this.createMarkup();
            this.open();
        }
        window.addEventListener('open_cookiebar', () => { 
            // Re-open cookie bar (for example when twitter consent should be added from the empty twitter box)
            // Open with: document.dispatchEvent(new CustomEvent('open_cookiebar', {bubbles: true}));
            this.createMarkup();
            this.loadSettings();
            this.open();
        });
        window.addEventListener('gtm_loaded', () => { this.eventsAfterGtmLoad() });
    }

    handleAction(action, param = null) {
        switch(action) {
            case "checkboxChange":
                this.consolidateCheckboxes(param);
                break;
            case "details":;
                $('.summary').removeClass('show');
                $('.details').addClass('show');
                break;
            case "summary":
                $('.details').removeClass('show');
                $('.summary').addClass('show');
                break;
            case "all":
                this.checkAll();
                this.saveSettings();
                this.applySettings();
                this.close();
                break;
            case "save":
                this.saveSettings();
                this.applySettings();
                this.close();
                break;
        }
    }

    open() {
        $('body').addClass('cookiebar-open');
    }

    close() {
        $('body').removeClass('cookiebar-open');
    }

    checkAll() {
        $('.cookiebar-content .consentitem input:not(:checked)').click();
    }

    consolidateCheckboxes(lastChecked) {
        if (lastChecked) {
            // Check / uncheck children and sibling
            $(`input[name=${lastChecked.prop('name')}]`).prop('checked', lastChecked.prop('checked'));
            cookieDefinition.forEach(group => {
                if (group.id == lastChecked.prop('name')) {
                    group.items.forEach(item => {
                        $(`input[name=${item.id}]`).prop('checked', lastChecked.prop('checked'));
                    });
                }
            });
        }
        // Uncheck parents is there is unchecked child
        cookieDefinition.forEach(group => {
            if (group.items.some(item => $(`input[name=${item.id}]`).prop('checked') == false)) {
                $(`input[name=${group.id}]`).prop('checked', false);
            } else {
                $(`input[name=${group.id}]`).prop('checked', true);
            }
        });
    }

    saveSettings() {
        let consents = $('.cookiebar-content .consentitem input:checked').map(function() {return $(this).prop('name')}).get();
        Cookies.set('cookieconsent', consents, {expires: 30});
    }

    loadSettings() {
        let consents = Cookies.getJSON('cookieconsent');
        consents.forEach(consentid => {
            $(`input[name=${consentid}]`).prop('checked', true);
        });
        this.consolidateCheckboxes();
    }

    applySettings() {
        let consents = Cookies.getJSON('cookieconsent');
        consents.forEach(consentid => {
            let item = this.getItemDefinition(consentid);

            if (item.addHead) {
                item.addHead.forEach(script => {
                    $(script).appendTo('head');
                });
            }

            $(`iframe[data-consentid='${consentid}']`).each(function(){
                $(this).prop('src', $(this).data('src'));
            });

            if (item && item.action) {
                item.action();
            }
            
        });
        
    }

    eventsAfterGtmLoad() {
        let consents = Cookies.getJSON('cookieconsent');
        consents.forEach(consentid => {
            let item = this.getItemDefinition(consentid);
            if (item.afterGtm) {
                let event = new CustomEvent(`cookieconsent_${consentid}`, { bubbles: true });
                dataLayer.push({'event': 'cookieconsent_analytics'});
                console.log(event);
                document.dispatchEvent(event);
            }
        });
    }

    getItemDefinition(id) {
        let found;
        cookieDefinition.forEach(group => {
            group.items.forEach(item => {
                if (item.id == id) found = item;
            });
        });
        return found;
    }

    createMarkup() {
        $('.cookiebar-content').html(`
            <div class="summary show">
                <h2>${summary.headline}</h2>
                <p>${summary.text}</p>
                <div class="buttons">
                    <button class="secondary ripple" data-action="details"   >${buttons.details}</button>
                    <button data-action="all"       >${buttons.accept}</button>
                </div>
            </div>
            <div class="details">

                <div class="button-column">
                    <button data-action="summary" class="secondary"><  ${buttons.back}</button>
                </div>

                <div class="main-column" >
                    <h2>${details.headline}</h2>
                    <p>${details.text}</p>
                    
                    <div class="details-container">

                        <div class="details-categories">
                        ${cookieDefinition.map(group => {
                            var isEssentialTags = group.id == 'essential' ? 'checked = "checked" disabled = "disabled"' : '';
                            return `
                            <div class="group">
                                <div class="toggle-switch ${group.id}">
                                    <input type="checkbox" name="${group.id}" id="detail_${group.id}" ${isEssentialTags} />
                                    <span class="checkmark"></span>
                                </div>
                                <label for="detail_${group.id}">${group.title} (${group.items.length})</label>
                            </div>
                            `;
                        }).join("")}
                        </div>

                        <hr class="divider"/>

                        <div class="details-list">
                            <div class="fade"></div>
                            <div class="cookies-list">
                        ${cookieDefinition.map(group => {
                            var isEssentialTags = group.id == 'essential' ? 'checked = "checked" disabled = "disabled"' : '';
                            
                            return `
                                <div class="cookie-category">
                                    <div class="group">
                                        <div class="toggle-switch ${group.id}">
                                            <input type="checkbox" name="${group.id}" id="detail_${group.id}" ${isEssentialTags} />
                                            <span class="checkmark"></span>
                                        </div>

                                        <label class="h3" for="detail_${group.id}" >${group.title} (${group.items.length})</label>
                                    </div>

                                    <p class="description">${group.description}</p>
                                    
                                    ${group.items.map(item => {
                                        
                                        return `
                                        <div class="cookie ${group.id}">
                                            
                                            <div class="group">
                                                <div class="consentitem toggle-switch ${item.id}">
                                                    <input type="checkbox" name="${item.id}" id="${item.id}" ${isEssentialTags} />
                                                    <span for="${item.id}" class="checkmark"></span>
                                                </div>

                                                <label for="${item.id}">${item.title}</label>
                                                <div class="openTable"></div>
                                            </div>


                                            <div class="table-container">
                                            <table class="cookiedetails">
                                                <tbody>
                                                ${Object.keys(item).map(detail => {
                                                    if (detaillabel[detail])
                                                    return `
                                                        <tr>
                                                            <td>${detaillabel[detail]}</td>
                                                            <td>${item[detail]}</td>
                                                        </tr>
                                                    `;
                                                }).join("")}
                                                </tbody>
                                            </table>
                                            </div>
                                        </div>
                                        `;
                                    }).join("")}
                                </div>
                            `;
                        }).join("")}
                        </div>
                        </div>
                    </div>

                    <button data-action="save">${buttons.saveAndClose}</button>
                </div>
            </div>
        `);
        var self = this;
        $('.cookiebar-content a[data-action], .cookiebar-content button[data-action]').click(function(e){
            e.preventDefault();
            self.handleAction($(this).data('action'));
        });
        $('.cookiebar-content input[type=checkbox]').change(function (e) {
            self.handleAction('checkboxChange', $(this));
        });

        $('.openTable').click((e) => {
            $(e.target).closest('.cookie').toggleClass('open');
        });

        // Accordeon
        cookieDefinition.forEach(group => {
            $(`.cookiebar-content .info-on.${group.id}`).on('click', (e) => {
                e.preventDefault();
                $(`.cookiebar-content .info-on.${group.id}`).removeClass('visible');
                $(`.cookiebar-content .cookie.${group.id}`).addClass('visible');
                $(`.cookiebar-content .info-out.${group.id}`).addClass('visible');
            });
        
            $(`.info-out.${group.id}`).on('click', (e) => {
                e.preventDefault();
                $(`.cookiebar-content .info-on.${group.id}`).addClass('visible');
                $(`.cookiebar-content .cookie.${group.id}`).removeClass('visible');
                $(`.cookiebar-content .info-out.${group.id}`).removeClass('visible');
            });
        });

    }
}

$(document).ready(function(){
    let cookiebar = new Cookiebar();
})